/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injector} from '@angular/core';
import {UIRouter} from '@uirouter/core';

import {createAdnRouterHelper} from './adn-router-helper-core';
import {buildFeatureStates} from './all-feature-states';

export function registerFeatureStates(uiRouter: UIRouter, ng2Injector: Injector): void {
  const adnRouterHelper = createAdnRouterHelper(ng2Injector);
  buildFeatureStates(adnRouterHelper).forEach((state) => {
    uiRouter.stateRegistry.register(state as any);
  });
}
